import Raven from "raven-js";
import { RAVEN_CONFIG_URL } from "../util/constants";

Raven.config(RAVEN_CONFIG_URL).install();

export const ravenUnHandledRejection = function(evt) {
  if (!!evt || !!evt.reason) {
    Raven.captureException(evt);
  } else {
    Raven.captureException(evt.reason);
  }
};

export default Raven;



// WEBPACK FOOTER //
// ./src/services/raven.js